import React, { useState } from "react";
// import { useEffect } from "react";
import * as FaIcons from "react-icons/fa";

const Carousel = ({ slides }) => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;
  // useEffect(() => {
  //   setTimeout(() => {
  //     nextSlide();
  //   }, 20000);
  // });

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };
  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };
  const moveDot = (index) => {
    setCurrent(index);
  };

  return !Array.isArray(slides) || length === 0 ? (
    <h1>No data available</h1>
  ) : (
    <section className="slider" id="carousel">
      <div
        className="arrow left-arrow"
        data-aos="fade-down"
        data-aos-easing="ease-in-out"
      >
        <FaIcons.FaArrowAltCircleLeft onClick={prevSlide} />
      </div>
      <div
        className="arrow right-arrow"
        data-aos="fade-down"
        data-aos-easing="ease-in-out"
      >
        <FaIcons.FaArrowAltCircleRight onClick={nextSlide} />
      </div>
      {slides.map((data, index) => (
        <div
          key={data.title}
          className={index === current ? "slide active" : "slide"}
        >
          {index === current && (
            <>
              <img
                src={require(`../../Assets/Images/carousel/${data.image}`)}
                className="slide-img"
                alt={data.image}
                data-aos="fade-left"
                data-aos-easing="ease-in-out"
              />
              <div
                className="slide-content"
                data-aos="fade-left"
                data-aos-easing="ease-in-out"
                data-aos-delay="200"
              >
                <h2 className="slide-title">{data.title}</h2>
                <div className="slide-description">
                  <p className="slide-desc1">{data.description_part1}</p>
                  <p className="slide-desc2">{data.description_part2}</p>
                </div>
              </div>
            </>
          )}
        </div>
      ))}
      <div className="container-dots">
        {Array.from({ length }).map((item, index) => (
          <div
            key={index}
            className={current === index ? "dot active" : "dot"}
            onClick={() => moveDot(index)}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default Carousel;
